import {
  CsegmentedpanelTone,
  CsegmentedpanelVariant,
} from "./csegmentedpanel.types";

export const CSEGMENTED_PANEL_VARIANTS: readonly CsegmentedpanelVariant[] = [
  CsegmentedpanelVariant.Seamed,
  CsegmentedpanelVariant.InsetCells,
  CsegmentedpanelVariant.SignalRails,
  CsegmentedpanelVariant.LabelBands,
];

export const DEFAULT_CSEGMENTED_PANEL_VARIANT = CsegmentedpanelVariant.Seamed;

export const CSEGMENTED_PANEL_TONE_COLOR: Record<CsegmentedpanelTone, string> =
  {
    [CsegmentedpanelTone.Positive]: "#66FEC1",
    [CsegmentedpanelTone.Negative]: "#FF6E84",
    [CsegmentedpanelTone.Caution]: "#F29F57",
    [CsegmentedpanelTone.Neutral]: "rgba(255,255,255,0.88)",
    [CsegmentedpanelTone.Muted]: "rgba(255,255,255,0.46)",
  };
